import { AccountInfo } from "@azure/msal-browser";
import { CONFIG } from "../config";

export function isDevModeEnabled(): boolean {
  return CONFIG.DEV_MODE;
}

export function getDevModeAllowedEmails(): string[] {
  const envValue = CONFIG.DEV_MODE_ALLOWED_EMAILS;
  
  if (!envValue) {
    return [];
  }

  const emails = envValue.split(',').map(email => email.trim()).filter(email => email.length > 0);

  const malformedEntries = emails.filter(email => !email.includes('@'));
  if (malformedEntries.length > 0) {
    console.warn('Dev mode: Found malformed email entries in allowlist:', malformedEntries);
  }

  return emails;
}

export function isUserInDevModeAllowlist(account: AccountInfo): boolean {
  if (!account || !account.username) {
    return false;
  }

  const allowedEmails = getDevModeAllowedEmails();
  if (allowedEmails.length === 0) {
    return false;
  }

  const userEmail = account.username.toLowerCase();
  return allowedEmails.some(email => email.toLowerCase() === userEmail);
}

export function hasDevModeAccess(account: AccountInfo): boolean {
  return isDevModeEnabled() && isUserInDevModeAllowlist(account);
}
